/**
 * Created by ashahab on 8/22/2017.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import Heading from "../../heading/heading";
import $ from "jquery";
import apiClient from "../../../actions/api-client";
import ProgressIndicator from "../../progress-indicator/progress-indicator";
import TextFieldGroup from "../../forms/text-field-group";
import {browserHistory} from "react-router";
import { Button, Modal, Alert } from 'react-bootstrap';
import "./custom.css"
import htmlParser from "../../common/htmlParser";


class StudentSubmission extends Component {

    constructor(props) {
        super(props);
        this.openStudentsPanel = this.openStudentsPanel.bind(this);
        this.showIndicator = this.showIndicator.bind(this);
        this.hideIndicator = this.hideIndicator.bind(this);
        this.getAssignmentDetails = this.getAssignmentDetails.bind(this);
        this.nextQuestion = this.nextQuestion.bind(this);
        this.previousQuestion = this.previousQuestion.bind(this);
        this.onChange = this.onChange.bind(this);
        this.saveQuestion = this.saveQuestion.bind(this);
        this.GradeAllEssaysWithAI = this.GradeAllEssaysWithAI.bind(this);
        this.submitResult = this.submitResult.bind(this);
        
        this.nextActivity = this.nextActivity.bind(this);
        this.previousActivity = this.previousActivity.bind(this);
        
        this.dialogueBoxClosingEditor = this.dialogueBoxClosingEditor.bind(this);
        this.saveAssignmentsPopup = this.saveAssignmentsPopup.bind(this);
        
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);

        this.panelStatus = true;

        this.state={allStudents:[],studentSelected:false, assignment:'', studentCompleted:false,
            loading: false, selectedStudentQuestions:[], selectedQuestionIndex:0, score:'', comments:'', scoreError:''};
    }

    componentWillMount()
    {
        if (this.props.location.state) {
            this.setState({allStudents:this.props.location.state.allStudents, assignment:this.props.location.state.assignment});
        }
    }

    openStudentsPanel()
    {
        
        if (this.panelStatus)
        {
            $('#studentsArea').addClass('leftBoxWidthMinimize');
            $('#questionsArea').addClass('rightBoxWidthMinimize');
            this.panelStatus = false;
        }
        else
        {
            $('#studentsArea').removeClass('leftBoxWidthMinimize');
            $('#questionsArea').removeClass('rightBoxWidthMinimize');
            this.panelStatus = true;
        }
    }
    showIndicator() {
        this.setState({
            ...this.state,
            loading: true
        });
    }

    hideIndicator() {
        this.setState({
            ...this.state,
            loading: false
        });
    }

    getAssignmentDetails(event)
    {
        let studentId = event.target.id ? event.target.id.split(':') : event.currentTarget.id.split(':');

        let context = this;
        context.showIndicator();
        let params = {};
        let pathTemplate = '/assignment/essay/assignmentID/'+this.state.assignment.id+'/student/'+studentId[0];
        apiClient.invokeApi(params, pathTemplate, 'GET', {}, {}, '3').then(function (result)
        { 
            context.hideIndicator();
            if (result.data.questions.length > 0)
            {
                context.setState({score:'',comments:'',selectedQuestionIndex:0,selectedStudentQuestions:result.data.questions, selectedStudentDetail:studentId[1], selectedStudentID: studentId[0], studentSelected:true, studentCompleted:false, showNullMessage:false});
                context.GradeAllEssaysWithAI();
            }
            else
            {
                context.setState({score:'',comments:'',selectedQuestionIndex:0,selectedStudentQuestions:[], selectedStudentDetail:studentId[1], selectedStudentID: studentId[0], studentSelected:false, studentCompleted:false, showNullMessage:true});
            }
            context.fetchJobStatus();
        }).catch(function (result) {
            context.hideIndicator();
        });
    }


    previousActivity()
    {
        
        let context = this;
        let allQuestions = this.state.selectedStudentQuestions;
        let index = this.state.selectedQuestionIndex;
        let score = parseInt(allQuestions[index].score ? allQuestions[index].score : this.state.score);
        if (score >=0 && score < 101)
        {
            let body = {
                assignment:this.state.assignment.id,
                assignmentID:allQuestions[index].assignmentID,
                questionID:allQuestions[index].questionID,
                studentID:allQuestions[index].stdID,
                activityID:allQuestions[index].activityID,
                comments:allQuestions[index].comments ? allQuestions[index].comments : this.state.comments,
                score:allQuestions[index].score ? allQuestions[index].score : this.state.score
            };


            if( this.state.assignment.activities["0"].activityID != this.state.assignment.activities["1"].activityID)
            {
                index=0;
            }

            context.showIndicator();
            let pathTemplate = '/assignment/comments';
            apiClient.invokeApi({}, pathTemplate, 'PUT', {}, body, '3').then(function (result)
            {
                index=0;
                index += 1;

                if (index >= allQuestions.length)
                {
                    context.setState({ showClassAssignmentMessage1: true });
                    context.setState({studentCompleted:true, studentSelected:false});
                }

                else
                {

                    context.setState({scoreError:'',comments:'',score:'',selectedQuestionIndex:index,selectedStudentQuestions:allQuestions});
                    context.fetchJobStatus();
                }
                context.hideIndicator();
            }).catch(function (result) {
                context.hideIndicator();
            });
        }
        else
        {
            this.setState({scoreError:'Please enter correct score. (0-100)'});
        }
    }


    nextActivity()
    {
        
        let context = this;
        let allQuestions = this.state.selectedStudentQuestions;
        let index = this.state.selectedQuestionIndex;
        let score = parseInt(allQuestions[index].score ? allQuestions[index].score : this.state.score);
        if (score >=0 && score < 101)
        {
            let body = {
                assignment:this.state.assignment.id,
                assignmentID:allQuestions[index].assignmentID,
                questionID:allQuestions[index].questionID,
                studentID:allQuestions[index].stdID,
                activityID:allQuestions[index].activityID,
                comments:allQuestions[index].comments ? allQuestions[index].comments : this.state.comments,
                score:allQuestions[index].score ? allQuestions[index].score : this.state.score
            };

            // while( this.state.assignment.activities["0"].activityID == this.state.assignment.activities["0"].activityID)
            // {
            //     index++;
            // }

            // if( this.state.assignment.activities["0"].activityID != this.state.assignment.activities["1"].activityID)
            // {
            //
            //     context.setState({ showClassAssignmentMessage1: true });
            //     context.setState({studentCompleted:true, studentSelected:false});
            // }

            context.showIndicator();
            let pathTemplate = '/assignment/comments';
            apiClient.invokeApi({}, pathTemplate, 'PUT', {}, body, '3').then(function (result)
            {
                index += 1;

                if (index >= allQuestions.length)
                {
                    context.setState({ showClassAssignmentMessage1: true });
                    context.setState({studentCompleted:true, studentSelected:false});
                }

                else
                {

                    context.setState({scoreError:'',comments:'',score:'',selectedQuestionIndex:index,selectedStudentQuestions:allQuestions});
                }
                context.hideIndicator();
            }).catch(function (result) {
                context.hideIndicator();
            });
        }
        else
        {
            this.setState({scoreError:'Please enter correct score. (0-100)'});
        }
    }


    nextQuestion()
    {
        
        let context = this;
        let allQuestions = this.state.selectedStudentQuestions;
        // let allQuestions1 = this.state.assignment.activities["0"].activityID;

        let index = this.state.selectedQuestionIndex;
        let score = parseInt(allQuestions[index].score ? allQuestions[index].score : this.state.score);
        if (score >=0 && score < 101)
        {
            let body = {
                assignment:this.state.assignment.id,
                assignmentID:allQuestions[index].assignmentID,
                questionID:allQuestions[index].questionID,
                studentID:allQuestions[index].stdID,
                activityID:allQuestions[index].activityID,
                comments:allQuestions[index].comments ? allQuestions[index].comments : this.state.comments,
                score:allQuestions[index].score ? allQuestions[index].score : this.state.score
            };



            context.showIndicator();
            let pathTemplate = '/assignment/comments';
            apiClient.invokeApi({}, pathTemplate, 'PUT', {}, body, '3').then(function (result)
            {

                index += 1;


                if (index >= allQuestions.length)
                {
                    context.submitResult((value) => {
                        if(value) {
                            context.setState({studentCompleted:true, studentSelected:false, showClassAssignmentMessage1: true}, context.hideIndicator);
                        } else {
                            console.log('error in the submit result')
                        }
                    })
                    // context.setState({ showClassAssignmentMessage1: true });
                    // context.setState({studentCompleted:true, studentSelected:false});
                }

                else
                {

                    context.setState({scoreError:'',comments:'',score:'',selectedQuestionIndex:index,selectedStudentQuestions:allQuestions});
                    context.fetchJobStatus();
                }
                
                if(index < allQuestions.length){
                   context.hideIndicator();
                }

            }).catch(function (result) {
                context.hideIndicator();
            });
        }
        else
        {
            this.setState({scoreError:'Please enter correct score. (0-100)'});
        }
    }

   async GradeAllEssaysWithAI(){
        const allQuestions = this.state.selectedStudentQuestions;
        for (const currentQuestion of allQuestions) {
            if (
                !currentQuestion.answer || 
                currentQuestion.answer.trim() === '' ||
                (currentQuestion.score !== 0 && currentQuestion.score != null) || 
                (currentQuestion.comments && currentQuestion.comments.trim() !== '')
            ) {
                continue;
            }
            this.gradeQuestionWithAI(currentQuestion);
        }
    }

    gradeQuestionWithAI = async (currentQuestion) => {
        
        this.showIndicator();
        let s3Key = '';
        if(currentQuestion.question.includes("img")){
            const imageUrl = this.extractImageUrls(currentQuestion.question)[0];
            s3Key = await this.uploadImageToServer(imageUrl);
        }
        const payload = {
                essay: currentQuestion.answer,
                question: currentQuestion.question
        };
        if(s3Key){
            payload.s3Key = s3Key;
        }
        apiClient.invokeApi({}, '/startEssayGrading', 'POST', {}, payload)
            .then(res => {
            console.log("Generation started:", res) 
            let gradingJobs = JSON.parse(sessionStorage.getItem('gradingJobs')) || [];
            gradingJobs.push({
                jobId: res.data.results.jobId, 
                studentID: currentQuestion.stdID, 
                assignmentID: currentQuestion.assignmentID, 
                questionID: currentQuestion.questionID
            });
            sessionStorage.setItem('gradingJobs', JSON.stringify(gradingJobs));
            this.setState({
                showAlert: true,
                essayGradingInProgress: true,
                alertStyle: 'success',
                alertText: 'Essay grading has started. The score will be updated once grading is complete.'
            });

            setTimeout(() => {
                if(this.state.essayGradingInProgress) {
                    this.setState({
                        showAlert: false,
                        alertStyle: '',
                        alertText: ''
                    });
                }
            }, 5000);
            setTimeout(() => {
                this.fetchJobStatus();
            }, 1000);

            this.hideIndicator();
            })
            .catch(err => {
            console.error("Error:", err);
            this.hideIndicator();
        });
    }

    async uploadImageToServer(imageUrl) {
        try {
            const fileName = this.getFilenameFromUrl(imageUrl);
            // 1️⃣ Start both requests in parallel
            // const imageFetchPromise = fetch(imageUrl, {
            //     mode: "cors"
            // });
            const imageFetchPromise = apiClient.invokeApi(
                {},
                '/fetchImage?url=' + encodeURIComponent(imageUrl),
                'GET',
                {},
                {}
            );

            const presignPromise = apiClient.invokeApi(
                {},
                '/essayGraderUploadURL?fileName=' + encodeURIComponent(fileName),
                'GET',
                {},
                {}
            );

            // Wait for both
            const [imageResponse, presignResult] = await Promise.all([imageFetchPromise, presignPromise]);

            console.log("imageResponse", imageResponse);
            console.log("presignResult", presignResult);

            // ✅ Handle image data
            // Your Lambda returns base64, so get it from the response
            const base64Data =  imageResponse.data || imageResponse.body || '';
            if (!base64Data) throw new Error('No image data returned');

            // Convert base64 → Blob
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Determine content type (default image/jpeg)
            const contentType =
            imageResponse.headers['Content-Type'] ||
            imageResponse.headers['content-type'] ||
            'image/jpeg';

            const blob = new Blob([byteArray], { type: contentType });

            // Convert to File
            const file = new File([blob], fileName, { type: contentType });

            console.log('File ready for upload:', file);

            // ✅ Use presigned URL to upload
            const { uploadUrl, s3Key } = presignResult.data;

            // 4️⃣ Upload to S3 using presigned URL
            const uploadRes = await fetch(uploadUrl, {
                method: 'PUT',
                headers: { 'Content-Type': file.type },
                body: file,
            });

            if (!uploadRes.ok) throw new Error('Upload to S3 failed');

            return s3Key;

        } catch (err) {
            console.error('Image upload failed:', err);
             this.setState({
                showAlert: true,
                essayGradingError: true,
                alertStyle: 'danger',
                alertText: 'Essay grading couldn’t be completed. Please try again, or reach out to support if the issue continues.'
            });
            setTimeout(() => {
                if(this.state.essayGradingError) {
                    this.setState({
                        showAlert: false,
                        alertStyle: '',
                        alertText: ''
                    });
                }
            }, 5000);
            this.setState({ error: 'Upload failed. Try again.', loading: false });
            throw err;
        }
    }

    async fetchJobStatus() {
        try {
            const allQuestions = this.state.selectedStudentQuestions;
            const index = this.state.selectedQuestionIndex;
            const currentQuestion = allQuestions[index];
            if (!currentQuestion) return;

            let gradingJobs = JSON.parse(sessionStorage.getItem('gradingJobs')) || [];
            const selectedJob = gradingJobs.find(
                job =>
                    job.studentID === currentQuestion.stdID &&
                    job.assignmentID === currentQuestion.assignmentID &&
                    job.questionID === currentQuestion.questionID
            );

            if (!selectedJob) {
                console.warn('No grading job found for this question.');
                return;
            }

            const res = await apiClient.invokeApi(
                {},
                `/pollEssayGrading?jobId=${selectedJob.jobId}`,
                'GET',
                {},
                {}
            );

            console.log("Job status response:", res);
            
            if (res.data.results.status === 'Running') {
                setTimeout(() => {
                    this.fetchJobStatus();
                }, 1000);
                return;
            } else if( res.data.results.status === 'Failed') {
                this.setState({ error: 'Essay grading failed. Please try again.' });
                return;
            }

            // Extract and clean the JSON inside the response
            const parsed = res.data.results.essayGrades;

            // Build the comment text
            const commentText = [
                `**Summary Feedback:** ${parsed.summary_feedback}`,
                '',
                '**Strengths:**',
                ...(parsed.strengths || []).map(s => `- ${s}`),
                '',
                '**Areas for Improvement:**',
                ...(parsed.areas_for_improvement || []).map(a => `- ${a}`),
                '',
                '**Recommendations:**',
                ...(parsed.specific_recommendations || []).map(r => `- ${r}`)
            ].join('\n');

            // Update component state
            if(selectedJob.questionID !== currentQuestion.questionID ||
               selectedJob.assignmentID !== currentQuestion.assignmentID ||
               selectedJob.studentID !== currentQuestion.stdID) {
                console.warn('Job details do not match the current question. Aborting update.');
                return;
            }
            const selectedQuestions = this.state.selectedStudentQuestions;
            selectedQuestions[this.state.selectedQuestionIndex].score = String(parsed.overall_score * 10);
            selectedQuestions[this.state.selectedQuestionIndex].comments = commentText;
            selectedQuestions[this.state.selectedQuestionIndex].AIGenerated = true;
            this.setState({
                score: String(parsed.overall_score * 10),
                comments: commentText,
                selectedStudentQuestions: selectedQuestions
            });
            this.setState({
                showAlert: true,
                alertStyle: 'success',
                alertText: 'AI grading complete! The score and feedback have been updated.',
                essayGradingInProgress: false,
                essayGradingError: false
            });

            setTimeout(() => {
                this.setState({
                    showAlert: false,
                    alertStyle: '',
                    alertText: ''
                });
            }, 5000);
            gradingJobs = gradingJobs.filter(job => !(
                job.studentID === currentQuestion.stdID &&
                job.assignmentID === currentQuestion.assignmentID &&
                job.questionID === currentQuestion.questionID
            ));
            sessionStorage.setItem('gradingJobs', JSON.stringify(gradingJobs));

        } catch (err) {
            console.error('Error fetching job status:', err);
            this.setState({ error: 'Failed to fetch job status.' });
        }
    }

    getFilenameFromUrl(url) {
        if (!url || typeof url !== 'string') return null;
        
        try {
            // Extract everything after the last "/" and before any "?"
            const pathname = new URL(url).pathname;
            const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
            return filename || null;
        } catch {
            // Fallback for cases where URL constructor fails (like non-absolute paths)
            const cleaned = url.split('?')[0];
            return cleaned.substring(cleaned.lastIndexOf('/') + 1) || null;
        }
    }

    extractImageUrls(rawText) {
        if (!rawText) return [];

        // Clean common JS-escaped sequences that often appear when HTML is embedded in a JS string
        let text = String(rawText)
        .replace(/\\n/g, ' ')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");

        const urls = new Set();

        // 1) find <img ... src="..."> or src='...'
        const imgRe = /<img[^>]*\s+src\s*=\s*(['"])(.*?)\1[^>]*>/gi;
        let m;
        while ((m = imgRe.exec(text)) !== null) {
        if (m[2]) urls.add(m[2]);
        }

        // 2) also catch bare http/https URLs (in case the image url appears without an <img>)
        const urlRe = /https?:\/\/[^\s"'<>]+/gi;
        while ((m = urlRe.exec(text)) !== null) {
            urls.add(m[0]);
        }

        return Array.from(urls);
    }

   saveQuestion()
    {
        
        let context = this;
        let allQuestions = this.state.selectedStudentQuestions;
        let index = this.state.selectedQuestionIndex;
        let score = parseInt(allQuestions[index].score ? allQuestions[index].score : this.state.score);
        if (score >=0 && score < 101)
        {
            let body = {
                assignment:this.state.assignment.id,
                assignmentID:allQuestions[index].assignmentID,
                questionID:allQuestions[index].questionID,
                studentID:allQuestions[index].stdID,
                comments:allQuestions[index].comments ? allQuestions[index].comments : this.state.comments,
                score:allQuestions[index].score ? allQuestions[index].score : this.state.score
            };

            console.log( 'assignmentID---->' + allQuestions[index].assignmentID);
            context.showIndicator();
            let pathTemplate = '/assignment/comments';
            apiClient.invokeApi({}, pathTemplate, 'PUT', {}, body, '3').then(function (result)
            {

                    context.setState({ showClassAssignmentMessage: true });
                    delete allQuestions[index].AIGenerated;
                    context.setState({selectedQuestionIndex:index,selectedStudentQuestions:allQuestions});

                context.hideIndicator();
            }).catch(function (result) {
                context.hideIndicator();
            });
        }
        else
        {
            this.setState({scoreError:'Please enter correct score. (0-100)'});
        }
    }

    previousQuestion()
    {
        
        let index = this.state.selectedQuestionIndex;
        if(index>0){
            index -= 1;
        }

        this.setState({selectedQuestionIndex:index,comments:'',score:'', scoreError:''});
        this.fetchJobStatus();

    }

    submitResult(callback) {

        // this.showIndicator();

        let body = {
            assignment:this.state.assignment.id,
            studentID: this.state.selectedStudentID,
            studentName: this.state.selectedStudentDetail,
            teacherName: this.props.auth.user.firstName + " " + this.props.auth.user.lastName
        }
        
        apiClient.invokeApi({}, '/submitEssayResult', "POST", {}, body, '5').then((result => {

            this.setState({
                showAlert: true,
                alertStyle: 'success',
                alertText: result.data
            }
            // , this.hideIndicator
            );

            setTimeout(() => {
                this.setState({
                    showAlert: false,
                    alertStyle: '',
                    alertText: ''
                })
            }, 5000);

            callback(true)
            
        }), error => {
            

            let responseData = [];
            let combinedMessage = '';
            if (error.response && error.response.data.errors) {
                for (let err of error.response.data.errors)
                    responseData.push(err.message)

                combinedMessage = responseData.join(', ')
            }

            this.setState({
                showAlert: true,
                alertStyle: 'danger',
                alertText: responseData.length != 0 && combinedMessage ? combinedMessage : error.message
                // alertText: 'Unable to load data, please contact administrator.'
            }
            // , this.hideIndicator
            );
            
            setTimeout(() => {
                this.setState({
                    showAlert: false,
                    alertStyle: '',
                    alertText: ''
                })
            }, 5000);

            callback(false)

        })

    }

    onChange(e)
    {
        
        this.setState({[e.target.id] : e.target.value});
        if (e.target.id === 'score')
        {
            let allQuestions = this.state.selectedStudentQuestions;
            allQuestions[this.state.selectedQuestionIndex].score = e.target.value;
            this.setState({selectedStudentQuestions:allQuestions});
        }
        else if (e.target.id === 'comments')
        {
            let allQuestions = this.state.selectedStudentQuestions;
            allQuestions[this.state.selectedQuestionIndex].comments = e.target.value;
            this.setState({selectedStudentQuestions:allQuestions});
        }

    }


    dialogueBoxClosingEditor()
    {

        return <Modal id="dialogCustomEntry"

                      show={this.state.showClassAssignmentMessage1}
                      backdrop="static"
                      onHide={() => {

                          this.setState({ showClassAssignmentMessage1: false });
                      }}
                      container={this}
                      aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>

                <h3>Your comments have been saved and submitted for your reports. Your students will now be able to see your comments</h3>
            </Modal.Body>
            <Modal.Footer>

                <Button onClick={() => {

                    this.setState({ showClassAssignmentMessage1: false });
                }} bsStyle='primary'>OK</Button>

            </Modal.Footer>
        </Modal>;

    }

    saveAssignmentsPopup()
    {

        return <Modal id="dialogCustomEntry"
                      container={this}
                      show={this.state.showClassAssignmentMessage}
                      backdrop="static"
                      onHide={() => {

                          this.setState({ showClassAssignmentMessage: false });
                      }}

                      aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>

                <h3>You have saved your comments. This will not be included in any reports, or sent to students until you select Submit</h3>
            </Modal.Body>
            <Modal.Footer>

                <Button onClick={() => {

                    this.setState({ showClassAssignmentMessage: false });
                }} bsStyle='primary'>OK</Button>

            </Modal.Footer>
        </Modal>;

    }

    handleAlertDismiss(e) {
        this.setState({'showAlert': false});
    }

    render()
    {
        let allStudentsHtml=[];
        let allStudents = this.state.allStudents;
        if (allStudents && allStudents.length > 0)
        {
            allStudents.forEach(student=>{
                allStudentsHtml.push(<li key={student.stdID + ':' + (student.firstName + ' ' + student.lastName)} style={this.state.selectedStudentID == student.stdID ? {background: "#1e88e5"} : {}}><a href="javascript:;" id={student.stdID + ':' + (student.firstName + ' ' + student.lastName)} onClick={this.getAssignmentDetails} style={this.state.selectedStudentID == student.stdID ? { color:"white" ,textTransform: "capitalize", whiteSpace: "nowrap" } : { textTransform: "capitalize", whiteSpace: "nowrap"}} className="anchorAdjustForSidePanel">{student.firstName + ' ' + student.lastName}
                    {
                        student.studentStatus == "completed" || student.progress == 100
                            ?
                            <span style={{whiteSpace: "nowrap"}}><span className="arrowTag"></span><span className="tag submitted">&#x25cf; Submitted</span></span>
                            : (student.progress > 0
                                ?
                                <span style={{whiteSpace: "nowrap"}}><span className="arrowTag"></span><span className="tag inProgress">&#9679; In Progress</span></span>
                                :
                                <span style={{whiteSpace: "nowrap"}}><span className="arrowTag"></span><span className="tag notSubmitted">&#9679; Not Submitted</span></span>
                            )
                    }
                </a>
                </li>);
            });
        }
        let nextButtonClass = 'nextQuesBtn ';
        let previousButtonClass = 'prevQuesBtn ';
        let NextButtonText = 'Next';
        let SaveButtonText = 'Save';
        let SubmitButtonText = 'Submit';
        if (this.state.selectedStudentQuestions && this.state.selectedStudentQuestions.length > 0)
        {
            nextButtonClass = this.state.selectedQuestionIndex+1 > this.state.selectedStudentQuestions.length ? 'nextQuesBtn disableLink':'nextQuesBtn ';
            NextButtonText = this.state.selectedStudentQuestions.length==1 ? "Submit" : this.state.selectedQuestionIndex+1 === this.state.selectedStudentQuestions.length ? 'Submit All':'Next';
            previousButtonClass = this.state.selectedQuestionIndex+1 === 1 ? 'prevQuesBtn disableLink' : 'prevQuesBtn ';
        }

        return(
            <di>
                <Heading
                    breadcrumbsData={
                        [
                            {
                                name: 'Manage Assignments', action: ()=> {
                                browserHistory.push({pathname: '/assignments', state: {assignmentFromDashboard:this.state.assignment}});
                            }
                            },
                            {
                                name: 'View Submissions', action: ()=> {
                            }
                            }
                        ]
                    }
                />
                <div  className="container-fluid">
                    <div  className="studentMangeSubProgTab">
                        {/*<ul  className="nav nav-tabs hidden-md hidden-lg">*/}
                            {/*<li  className=""><a data-toggle="tab" href="#manage" aria-expanded="true">Manage</a></li>*/}
                            {/*<li  className=""><a data-toggle="tab" href="#progress" aria-expanded="false">Progress</a></li>*/}
                            {/*<li  className="active"><a data-toggle="tab" href="#submission" aria-expanded="false">Submission</a></li>*/}
                        {/*</ul>*/}
                        <div  className="tab-content">
                            <div id="submission"  className="tab-pane fade in active">
                                <div id="studentsArea"  className="anchorLeftBox  ">
                                    <div  className="ArrowDivCollapse "> <span onClick={this.openStudentsPanel} className="ArrowExpand"/> </div>
                                    <div  className="overFlowScroll-sm">
                                        <h3>Student Name</h3>
                                        <div  className="StdNameBox">
                                            <ul  className="StdNameList">
                                                {allStudentsHtml}
                                            </ul>
                                        </div>
                                    </div>
                                </div>




                                {this.state.studentSelected && !this.state.studentCompleted && <div id="questionsArea"  className="mainActivBoxRight ">

                                        <div>
                                            <h3 className="studentNameHeadingEssay">{this.state.selectedStudentDetail}</h3>
                                            <h2 className="assignmentNameHeadingEssay">{this.state.assignment.assignmentName}</h2>
                                        </div>

                                    {false && <div  className="eleRow hidden-xs">

                                        <div  className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                            <h3>{this.state.selectedStudentDetail}</h3>
                                        </div>



                                        <div  className="col-lg-6 col-md-5 col-sm-7 col-xs-7 text-center">
                                            <h3>{this.state.assignment.assignmentName}</h3>
                                        </div>


                                        <div className="col-md-4 col-sm-5  col-xs-5 text-right"><a href="javascript:;"  onClick={this.previousQuestion} className="backwardarrow" > 🡸 </a></div>
                                        <div  className="col-md-4 col-sm-5  col-xs-5 text-center">
                                            <p  className="quesNum">{(this.state.selectedQuestionIndex+1)+'/'+this.state.selectedStudentQuestions.length}</p>
                                        </div>

                                        <div className="col-md-4 col-sm-5  col-xs-5 text-left"><a href="javascript:;" onClick={this.nextQuestion} className="forwardarrow"> 🡺 </a></div>



                                        <div   style={{marginRight:'20%'}}>
                                            <Button onClick={()=> {
                                                // this.switchActivity(this.state.activitySwitchAct, this.state.activitySwitchUnitId);
                                                this.previousActivity()
                                            }} bsStyle='primary'>Previous Activity</Button>
                                        </div>


                                        <div>
                                            <Button onClick={()=> {
                                                // this.switchActivity(this.state.activitySwitchAct, this.state.activitySwitchUnitId);
                                                this.nextActivity()
                                            }} bsStyle='primary'>Next Activity</Button>
                                        </div>


                                        <div  className=" col-lg-2 col-md-3 col-sm-3 text-right hidden-sm ">
                                            {/*<button  className="wordBtn"/>*/}
                                            {/*<button  className="printBtn"/>*/}
                                        </div>
                                    
                                    </div>}


                                    <div  className="QuesAnsScoreBoxMain">
                                        <div  className="QuesAnsScoreRow">
                                            <div  className="col-md-2 col-sm-2 col-lg-10Per">
                                                <h3  className="lblheading">Question:</h3>
                                            </div>
                                            <div  className="col-md-9 col-sm-9 ">
                                                <p className="detailLbl seeFullQues" style={{marginTop:'20px'}}>{htmlParser(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].question ? this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].question.replace('[[[LP_ANSWERS]]]', '') : '')}</p>
                                            </div>
                                        </div>
                                        <div className="answer-comment-side-by-side">
                                            <div className="QuesAnsScoreRow d-flex">
                                                <div  className="px-4">
                                                    <h3  className="lblheading">Answer:</h3>
                                                </div>
                                                <div className="textarea-container px-4">
                                                    <textarea id="answer" disabled={true} rows='15' className="form-control form-group commentareaField" placeholder="Enter Comments" onChange={this.onChange} value={htmlParser(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].answer ? this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].answer : '')}/>
                                                </div>
                                            </div>
                                            <div className="QuesAnsScoreRow d-flex">
                                                <div className="px-4">
                                                    <h3 className="lblheading">Comments:</h3>
                                                </div>
                                                <div className="textarea-container px-4">
                                                    <textarea id="comments" rows='15' className="form-control form-group commentareaField" placeholder="Enter Comments" onChange={this.onChange} value={(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].comments) ? (this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].comments):this.state.comments}/>
                                                    {(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].AIGenerated) && <div className="AIGeneratedWarningMessage">* This comment was generated by AI. Please review and modify if needed before saving.</div>}
                                                </div>
                                            </div>
                                        </div>

                                        <div  className="QuesAnsScoreRow scringTipRow">
                                            <div  className="col-md-2 col-sm-2 col-lg-10Per">
                                                <h3  className="lblheading">Scoring tips:</h3>
                                            </div>
                                            <div  className="col-md-10 col-sm-9">
                                                <p  className="">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor.</p>
                                            </div>
                                        </div>
                                        <div  className="QuesAnsScoreRow">
                                            <div  className="col-md-2 col-sm-2 col-lg-10Per">
                                                <h3  className="lblheading">Score:</h3>
                                            </div>
                                            <div  className="col-md-7 col-sm-7" style={{ paddingRight: "0" }}>
                                                <TextFieldGroup
                                                    error={this.state.scoreError}
                                                    id="score"
                                                    field="score"
                                                    value={(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].score) ? (this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].score):this.state.score}
                                                    placeholder="Enter score"
                                                    onChange={this.onChange}
                                                />
                                                {(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].AIGenerated) && <div className="AIGeneratedWarningMessage">* This score was generated by AI. Please review and modify if needed before saving.</div>}

                                                
                                                {/*<input id="score" type="text"  className="form-control quesScoreField"  onChange={this.onChange} />*/}
                                                {/*<span  className="outOf"> /10 </span>*/}
                                                {/*<button  className="showScorDivBtn" >Show scoring tips</button>*/}
                                            </div>
                                            <p className="outOf">out of <b>100</b></p>

                                            {/*<p className="outOf">/10</p>*/}

                                            <a className = "Activity-toolTip toolTipCus tooltip-pos"><span className = "essayToolTipText tooltiptext"style={{ fontWeight: 'normal' }}>This score is based on the average of all the scores of all assigned activities. Incomplete or un-started activities count towards this average as 0%</span></a>

                                        </div>
                                 {       // <div  className="QuesAnsScoreRow">
                                        //     <div  className="col-md-2 col-sm-2  col-lg-10Per">
                                        //         <h3  className="lblheading">Comments:</h3>
                                        //     </div>
                                        //     <div  className="col-md-10 col-sm-10 ">
                                        //         <textarea id="comments" rows='10' className="form-control form-group commentareaField" placeholder="Enter Comments" onChange={this.onChange} value={(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].comments) ? (this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].comments):this.state.comments}/>
                                        //         {(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex] && this.state.selectedStudentQuestions[this.state.selectedQuestionIndex].AIGenerated) && <div className="AIGeneratedWarningMessage">* This comment was generated by AI. Please review and modify if needed before saving.</div>}
                                        //     </div>
                                        // </div>
                                }
                                        <div  className="QuesAnsScoreRow">


                                            <div className="col-md-4 col-sm-4 col-xs-3 text-center"><a href="javascript:;" style={{textDecoration: "none"}} onClick={this.previousQuestion} className={previousButtonClass}>&#9668; Previous</a></div>


                                            <div className="col-md-4 col-sm-4 col-xs-6 text-center">
                                                <a href="javascript:;" style={{textDecoration: "none"}} onClick={this.saveQuestion} className={nextButtonClass}>{SaveButtonText}</a>
                                                {<a href="javascript:;" style={{textDecoration: "none"}} onClick={() => this.gradeQuestionWithAI(this.state.selectedStudentQuestions[this.state.selectedQuestionIndex])} className={nextButtonClass}>Regrade Essay</a>}
                                            </div>


                                            <div className="col-md-4 col-sm-4 col-xs-3 text-left text-center"><a href="javascript:;" style={{textDecoration: "none"}} onClick={this.nextQuestion} className={nextButtonClass}>{NextButtonText} &#9658;</a></div>
    
                                            <div  className="col-md-12 col-sm-12 col-xs-12 text-center">
                                                <div  className="seqNum">{(this.state.selectedQuestionIndex+1)+' / '+this.state.selectedStudentQuestions.length}</div>
                                            </div>

                                            <div  className="col-md-4 col-sm-4 col-xs-2 text-center" style={{  marginBottom: '10%' }}>
                                            {/* <a href="javascript:;" onClick={this.submitResult} className={nextButtonClass}>{SubmitButtonText}</a> */}
                                            </div>

                                            {/*<Button style={{ width: "75px", height: "40px", backgroundColor: '#44a9f2' , borderColor: '#44a9f2', marginTop: '-11%', marginLeft: '53%',    cursor: 'pointer'}} onClick={this.nextQuestion} bsStyle='primary'>Save</Button>*/}
                                            
                                        </div>
                                    </div>
                                </div>}

                                {this.state.showClassAssignmentMessage1 && this.dialogueBoxClosingEditor()}
                                {this.state.showClassAssignmentMessage && this.saveAssignmentsPopup()}

                                {!this.state.studentSelected && !this.state.studentCompleted && this.state.showNullMessage && <div className="mainActivBoxRight "> <h3 style={{marginLeft: "20px" }}>This student have not attempted this assignment yet, please select another student to review</h3> </div>}
                                {!this.state.studentSelected && !this.state.studentCompleted && !this.state.showNullMessage && <div className="mainActivBoxRight "> <h3 style={{marginLeft: "20px" }}>Select a student to view submission</h3></div>}
                                +{!this.state.studentSelected && this.state.studentCompleted && !this.state.showNullMessage && <div className="mainActivBoxRight "> <h3 style={{marginLeft: "20px" }}>All done, Select another student to continue or start over</h3> </div>}
                            </div>
                        </div>
                    </div>
                    {this.state.showAlert &&
                        <div className="row">
                            <div className="col-md-3 col-xs-3" />
                            <div className="col-md-6 col-xs-3">
                                <Alert bsStyle={this.state.alertStyle}
                                    onDismiss={this.handleAlertDismiss}>
                                    {this.state.alertText}
                                </Alert>
                            </div>
                            <div className="col-md-3 col-xs-3" />
                        </div>
                    }
                </div>
                <ProgressIndicator show={this.state.loading}/>
            </di>
        );
    }
}

function mapStateToProps(state) {
    return {...state};
}
export default connect(mapStateToProps)(StudentSubmission);
